import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { afterSignInPath } from '../../utils/referral'

/**
 * Once signed in, someone who arrived by a share link (/join/<code>) is
 * taken to that creator's page, once. Lives in the signed-in app rather
 * than the login and sign-up pages, which stay as they are.
 */
const PendingReferralRedirect = () => {
  const navigate = useNavigate()
  useEffect(() => {
    const path = afterSignInPath()
    if (path !== '/') navigate(path, { replace: true })
  }, [navigate])
  return null
}

export default PendingReferralRedirect
